import PageContainer from './page_container';

const Page = PageContainer;
export default Page;
